import React from "react";
import { Select } from "antd";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import cookie from "js-cookie";
import moment from "moment";
import { IDocumentsActive, IDocumentType } from "store/lobby/lobby-model";
import TokenService from "utils/auth/Token.service";
import { isCpfDocumentType } from "utils/documentType";
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
globalThis.dayjs = dayjs;

export const hex2rgba = (hex: string, alpha = "0") => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const convertToTime = (eventTime) => {
  const dateTimeNow = dayjs().utc().local().format("YYYY-MM-DDTHH:mm:ss");
  const eventTimeConverted = dayjs.utc(eventTime).local().format("YYYY-MM-DDTHH:mm:ss");

  const diff = dayjs(dateTimeNow).diff(dayjs(eventTimeConverted));
  const duration = dayjs.duration(diff);

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();

  const timeConvert = `${days.toString().padStart(2, "0")}d ${hours.toString().padStart(2, "0")}h ${minutes.toString().padStart(2, "0")}m`;
  return timeConvert;
};

export const convertTimeSpanToTime = (lenghtOfStay) => {
  const duration = moment.duration(lenghtOfStay);

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();

  const timeConvert = `${days.toString().padStart(2, "0")}d ${hours.toString().padStart(2, "0")}h ${minutes.toString().padStart(2, "0")}m`;
  return timeConvert;
};

export const formattedDateNow = () => dayjs.utc().format();

export const validationCharacters = (evt, regex) => {
  const theEvent = evt || window.event;
  if (!theEvent || !theEvent.key) return;
  if (!regex.test(theEvent.key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};

export const mountArrayOffNotEmpty = (arr) => arr.filter((item) => item).map((str) => str.toUpperCase());

export const verifyIsNull = (item) => (item === undefined || item === "" || item === null ? null : item);

export const hasNull = (target) => {
  for (const member in target) {
    if (target[member] == null) {
      return true;
    }
  }
  return false;
};

export const mountArrayDrivers = (cpf1, driver1) => {
  const cpf1Data = verifyIsNull(cpf1);
  const driver1Data = verifyIsNull(driver1);
  const driverInfo1 = { name: driver1Data, cpf: cpf1Data };

  if (cpf1Data === null && driver1Data === null) {
    return [];
  } else {
    return [driverInfo1];
  }
};

export const mountArrayOfInvoiceNotEmpty = (arr) => arr.filter((item) => item);

const AFR_DOCUMENT_LABELS = {
  ZEMT: "Outbound Delivery (ZEMT)",
  ZINT: "Inbound Delivery (ZINT)",
  NB: "Marketplace Inbound Delivery (NB)",
};

export const getDocumentLabel = (description, isAfrDocumentsFlow = false) => (isAfrDocumentsFlow ? AFR_DOCUMENT_LABELS[description] || description : description);

export const mountArrayOfDocuments = (documents, formaData) => {
  const formatedAllDocuments = documents.map((document) => ({
    id: document.id,
    name: document.description,
    values: formaData[document.description] ?? [""],
  }));
  const arrOfDocuments = [];
  formatedAllDocuments.forEach((document) => {
    document.values.forEach((value) => {
      if (value) {
        arrOfDocuments.push({
          documentId: document.id,
          type: document.name,
          value: value.toUpperCase(),
        });
      }
    });
  });
  return arrOfDocuments;
};

export const filterVehicleByPlate = (options, filter) => {
  const arrayFilter = options.map((l) => l.vehiclePlate.toUpperCase());
  const filtered = arrayFilter.filter((link) => link.includes(filter));
  return options.filter((x) => filtered.includes(x.vehiclePlate.toUpperCase()));
};

export const checkRegistersVehicles = (registers, filter) => {
  let vehiclesFiltered = registers;
  if (filter) {
    vehiclesFiltered = filterVehicleByPlate(registers, filter);
  }
  return vehiclesFiltered;
};

export const setFieldsDocuments = (documents, form) => {
  if (documents?.length >= 1) {
    documents?.forEach((y) => {
      const active = documents?.filter((x) => x.type === y.type).map((x) => x.value);
      form.setFieldsValue({ [y.type]: active });
    });
  }
};

export const resetFieldsDocuments = (documentsList) => ({ documents: documentsList?.map(({ description }) => ({ type: description, value: "" })) });

export const checkWhenDocumentsIsEmpty = (documentsList, documents, form) => {
  const resetDocuments = resetFieldsDocuments(documentsList);
  documents?.length === 0 ? setFieldsDocuments(resetDocuments.documents, form) : setFieldsDocuments(documents, form);
};

export const onChangeFieldValue = (state, fieldName, value) => ({
  ...state,
  [fieldName]: value,
});

export const diffMinutesToRefreshToken = (expireTime: number) => {
  const expire = new Date(expireTime * 1000);
  const now = dayjs();
  const diff = now.diff(expire, "minute");
  const minutes = Math.abs(diff);
  console.log("diffMinutesToRefreshToken", minutes);
  if (minutes <= 5) {
    return true;
  }
  return false;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const roleName = (role: string, roles: any) => roles.filter((x) => x.description == role && x.id)[0].id;

export const mapSelect = (item) =>
  item?.map(({ description }, index) => (
    <Select.Option value={description} key={index}>
      {description}
    </Select.Option>
  ));

export const mapSelectObject = (item) =>
  item?.map((option, index) => (
    <Select.Option value={JSON.stringify(option)} key={index}>
      {option.description}
    </Select.Option>
  ));

export const mapSelectId = (item) =>
  item?.map((option) => (
    <Select.Option value={option.id} key={option.id}>
      {option.description}
    </Select.Option>
  ));

export const parseLocation = (location) => {
  return JSON.parse(location);
};

export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export function removeItemOnce(arr, value) {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

export const orderByFilterTable = (item) => (item.filter.orderBy !== undefined ? capitalizeFirstLetter(item.filter.orderBy) : "");

export const isNull = (item) => (item === undefined || item.length === 0 ? null : item);

export const isPlateNull = (plate) => {
  return plate !== "" ? true : false;
};

export const maxRangeDate = (current, dates, maxDaysSelect) => {
  if (!dates || dates.length === 0) {
    return false;
  }
  const tooLate = dates[0] && current.diff(dates[0], "days") > maxDaysSelect;
  const tooEarly = dates[1] && dates[1].diff(current, "days") > maxDaysSelect;
  return tooEarly || tooLate;
};

export const searchLocationIdSelected = (key, array) => {
  for (const item of array) {
    if (item.description === key) {
      return item.id;
    }
  }
};

export const searchLocationsSelected = (key, array) => {
  const locations = [];
  for (const location of array) {
    if (key.includes(location.description)) {
      locations.push({ id: location.id, description: location.description });
    }
  }
  return locations;
};

export const searchLocationByIdSelected = (key, array, userData) => {
  const locations = [];
  if (key[0] === userData.location) {
    locations.push(userData.locationId);
  }
  for (const item of array) {
    for (const description of key) {
      if (item.description === description) {
        locations.push(item.id);
      }
    }
  }
  const locationsById = [...new Set(locations)];
  return locationsById;
};

export const setCookiesCurrentPage = (nameItem: string) => {
  const currentPage = {
    lobby: "1",
    reports: "2",
    units: "4",
    users: "5",
    userEdit: "6",
    locationRegistration: "7",
    unitEdition: "8",
    attendance: "12",
    inboundOutbound: "13",
  };
  cookie.set("menuItemActive", currentPage[nameItem]);
};

export const verifyDrivers = (respData, documentType: IDocumentType) => {
  let bodyRequest = respData;
  let cpf1 = undefined;
  let driver1 = undefined;
  const formatCPF = (cpf: string) => {
    const digits = cpf.replace(/\D/g, "");
    if (digits.length === 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    return digits;
  };

  const cleanDocument = (doc: string) => doc.replace(/[.\-]/g, "");
  const normalizeDocument = (doc: string) => (isCpfDocumentType(documentType) ? formatCPF(doc) : cleanDocument(doc));

  if (respData && respData?.drivers) {
    respData.drivers?.forEach((item, index) => {
      const rawCpf = item.cpf ?? "";
      const normalizedCpf = normalizeDocument(rawCpf);
      if (index === 0) {
        driver1 = item.name;
        cpf1 = normalizedCpf;
      }
    });
    bodyRequest = { ...bodyRequest, driver1, cpf1 };
  }
  return bodyRequest;
};

export const isStateOrAction = (state, action) => (state === null ? action : state);

export function tokenDecodedUser(userData) {
  const tokenService = new TokenService();
  const tokenDecode = tokenService.decodeToken();
  if (tokenDecode) {
    userData.email = tokenDecode.email;
    userData.username = tokenDecode.name;
    userData.location = tokenDecode.locationDescription;
    userData.locationId = +tokenDecode.locationId;
    userData.warehouseCode = tokenDecode.warehouseCode;
    userData.role = tokenDecode.role;
    userData.isConcierge = isConcierge(tokenDecode.role);
    userData.acceptLanguage = tokenDecode.acceptLanguage;
  }
}

export enum Roles {
  UNKNOWN = "Desconhecido",
  VISIT = "Consulta",
  CONTROL = "Controle",
  CONCIERGE = "Portaria",
  ADMIN = "Admin",
  CONCIERGE_LEADER = "Líder de Portaria",
  ATTENDANCE = "Atendimento",
  CONCIERGE_ATTENDANCE = "Portaria/Atendimento",
}

export const languageOptions = [
  { id: 0, description: "pt-BR" },
  { id: 1, description: "es-MX" },
  { id: 2, description: "en-US" },
];

export function isConcierge(role) {
  return role === Roles.CONCIERGE || role === Roles.ADMIN || role === Roles.CONCIERGE_LEADER || role === Roles.CONCIERGE_ATTENDANCE;
}

export const isRoleAuthorizedToEditEntry = (userRole) => {
  const authorizedRoles = [Roles.CONCIERGE_LEADER, Roles.CONCIERGE, Roles.CONCIERGE_ATTENDANCE, Roles.ADMIN];
  return (Object.values(authorizedRoles) as string[]).includes(userRole);
};

export function isRoleAuthorizedToFinishVehicle(role) {
  const authorizedRoles = [Roles.ADMIN, Roles.CONCIERGE_LEADER, Roles.CONCIERGE, Roles.ATTENDANCE, Roles.CONCIERGE_ATTENDANCE];
  return (Object.values(authorizedRoles) as string[]).includes(role);
}

export function isAttendanceAndAdmin(role) {
  return role === Roles.ADMIN || role === Roles.ATTENDANCE || role === Roles.CONCIERGE_ATTENDANCE;
}

export function isAdminLocal(role) {
  return role === Roles.ADMIN || role === Roles.CONCIERGE_LEADER;
}

export function isUnknown(role) {
  return role === Roles.UNKNOWN;
}

export function isConciergeAndVisit(role) {
  return role === Roles.CONCIERGE || role === Roles.CONCIERGE_ATTENDANCE || role === Roles.VISIT || role === Roles.UNKNOWN;
}

export const searchProcessByDescriptionSelected = (key, array) => {
  let process;
  for (const item of array) {
    if (item.description === key) {
      process = item.id;
    }
  }
  return process;
};

export const searchProcessByIdSelected = (key, array) => {
  let process;
  for (const item of array) {
    if (item.processId === key) {
      process = item.description;
    }
  }
  return process;
};

export const searchProcessCorrelationIdSelectedById = (key, array) => {
  let process;
  for (const item of array) {
    if (item.processId === key) {
      process = item.correlationId;
    }
  }
  return process;
};

export const searchSaleChannelByIdSelected = (key, array) => {
  let saleChannel;
  for (const item of array) {
    if (item.id === key) {
      saleChannel = item.description;
    }
  }
  return saleChannel;
};

export const searchSaleChannelByDescriptionSelected = (key, array) => {
  let saleChannel;
  for (const item of array) {
    if (item.description === key) {
      saleChannel = item.id;
    }
  }
  return saleChannel;
};

export const checkIfAddDocumentsByProcessId = (outboundProcess, registerActive, documentsList, formCheckout) => {
  if (!outboundProcess.includes(registerActive.processId)) {
    checkWhenDocumentsIsEmpty(documentsList, registerActive?.documents, formCheckout);
  }
};

export const checkDocumentIfIsNumber = (ids, documents, documentsList) => {
  documents.map(function (item) {
    if (isNaN(item.id)) {
      ids.push(searchProcessByDescriptionSelected(item.id, documentsList));
    } else {
      ids.push(item.id);
    }
    return ids;
  });
};

export const checkDocumentId = (documentId, id) => (documentId === undefined ? id : documentId);

export const vehicleStepsSelected = (key, array) => {
  let vehicle = [];
  vehicle = [];
  for (const item of array) {
    for (const k of key) {
      if (item.id === k) {
        vehicle.push(item.vehicleSteps);
      }
    }
  }
  return [...new Set(vehicle)];
};

export const unauthorizedRolesInYardManagementCardActions = (userRole) => {
  const unauthorizedRoles = [Roles.ATTENDANCE, Roles.CONCIERGE, Roles.CONCIERGE_LEADER, Roles.CONTROL, Roles.CONCIERGE_ATTENDANCE, Roles.VISIT];
  return (Object.values(unauthorizedRoles) as string[]).includes(userRole);
};

export const unauthorizedRolesInYardManagementTableActions = (userRole) => {
  const unauthorizedRoles = [Roles.CONCIERGE, Roles.CONCIERGE_LEADER, Roles.CONTROL, Roles.VISIT];
  return (Object.values(unauthorizedRoles) as string[]).includes(userRole);
};

export const unauthorizedRolesInLobbyTableActions = (userRole) => {
  const unauthorizedRoles = [Roles.CONTROL, Roles.ATTENDANCE, Roles.CONCIERGE_LEADER, Roles.CONCIERGE, Roles.CONCIERGE_ATTENDANCE, Roles.VISIT];
  return (Object.values(unauthorizedRoles) as string[]).includes(userRole);
};

export const isRoleAuthorizedToReleaseVehicle = (userRole) => Roles.ADMIN === userRole || Roles.ATTENDANCE === userRole || Roles.CONCIERGE_ATTENDANCE === userRole;

const availableVehicleSteps = [
  { id: 1, identifier: "64ac14a0-4111-4f8e-aa31-01764e196870" },
  { id: 2, identifier: "365c6182-ac63-47f4-922f-a79309402067" },
  { id: 3, identifier: "d462b41a-5514-4105-8bb7-78343855c878" },
  { id: 4, identifier: "49c3d9ea-a3f8-4437-a62d-15de701d68bb" },
];

export const searchVehicleStepsIdentifierById = (key) => {
  const vehicleSteps = [];
  for (const step of availableVehicleSteps) {
    for (const k of key) {
      if (step.id === k) {
        vehicleSteps.push(step.identifier);
      }
    }
  }
  const vehicleStepsIdentifier = [...new Set(vehicleSteps)];
  return vehicleStepsIdentifier;
};

export const searchVehicleStepsIdByIdentifier = (key) => {
  const vehicleSteps = [];
  for (const step of availableVehicleSteps) {
    for (const k of key) {
      if (step.identifier === k) {
        vehicleSteps.push(step.id);
      }
    }
  }
  const vehicleStepsId = [...new Set(vehicleSteps)];
  return vehicleStepsId;
};

export const searchIdByDescriptionSelected = (key, array) => {
  let id = [];
  id = [];
  for (const item of array) {
    for (const k of key) {
      if (item.description === k) {
        id.push(item.id);
      }
    }
  }
  return [...new Set(id)];
};

export const searchProcessesIdByDescriptionSelected = (key, array) => {
  let id = [];
  id = [];
  for (const item of array) {
    for (const k of key) {
      if (item.description === k) {
        id.push(item.processId);
      }
    }
  }
  return [...new Set(id)];
};

export const checkPermissionPage = (router, navigation, hasAttendance, hasConfigurationLoaded, lobbyHasConfigurationNotLoaded, hasRfidReading) => {
  const pathAttendanceActive = router.pathname.startsWith("/private/attendance");
  const pathTagsActive = router.pathname.startsWith("/private/readers-tags");
  if ((!hasAttendance && pathAttendanceActive && hasConfigurationLoaded) || (!hasRfidReading && pathTagsActive && hasConfigurationLoaded)) {
    navigation("/private/lobby");
    setCookiesCurrentPage("lobby");
    lobbyHasConfigurationNotLoaded();
  }
};

export const removeUnnecessaryDocument = (arr, type) => {
  const documents = arr.filter(function (value) {
    return value.type !== type;
  });

  return documents;
};

export const onExtractDocumentsValue = (documents: IDocumentsActive[]) => {
  const filterDocuments = documents?.filter((document) => document.type === "DT");
  const documentsValues = filterDocuments.map((document) => document.value);
  return documentsValues;
};

export const truncateText = (text: string, maxLength = 60): string => {
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};
